<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">客户管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">资源回收</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 资源回收 -->
    <div class="content">
      <h2>资源回收</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" id="search" class="search-form" size="small">
          <el-form-item label="年份">
            <el-date-picker
              v-model="search.year"
              type="year"
              placeholder="请选择年份"
              format="yyyy"
              value-format="yyyy"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否成交">
            <el-select
              v-model="search.hasOrder"
              placeholder="请选择是否成交"
              clearable
            >
              <el-option label="未成交" :value="0"></el-option>
              <el-option label="已成交" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每页条数">
            <el-input
              v-model.number="customPageSize"
              placeholder="请输入每页条数"
              type="number"
              :min="1"
              :max="1000"
              clearable
              @keyup.native.enter="applyCustomPageSize"
            >
              <el-button slot="append" @click="applyCustomPageSize">应用</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
            <el-button type="success" @click="handleExport" :loading="exportLoading">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3>待回收客户列表</h3>
      <lb-table
        v-horizontal-scroll='always'
        :column="column"
        :data="list"
        pagination
        :total="page.totalNum"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 50, 100]"
        :current-page.sync="page.currentPage"
        :page-size="page.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      >
      </lb-table>
    </div>
  </div>
</template>

<script>
import LbTable from '../../components/lb-table/lb-table'
export default {
  name: 'resourceRecycle',
  components: { LbTable },
  data () {
    return {
      search: {
        year: new Date().getFullYear().toString(), // 年份
        hasOrder: '' // 是否成交 0-未成交，1-已成交
      },
      customPageSize: null, // 自定义每页条数
      list: [], // 列表
      column: [
        { label: '客户ID', prop: 'customerId', width: '100' },
        { label: '客户姓名', prop: 'customerName', width: '120' },
        { label: '手机号', prop: 'phone', width: '130' },
        { label: '备用手机号', prop: 'phone1', width: '130' },
        { label: '微信号', prop: 'wechatNo', width: '120' },
        { label: '备用微信号', prop: 'wechatNo2', width: '120' },
        { label: 'QQ号', prop: 'qqNo', width: '120' },
        { label: '备用QQ号', prop: 'qqNo2', width: '120' },
        { label: '邮箱', prop: 'email', width: '180' },
        { label: '备用邮箱', prop: 'email2', width: '180' },
        { label: '客服ID', prop: 'serviceUserId', width: '100' },
        { label: '资源时间', prop: 'resourceTime', width: '180' },
        { label: '分配时间', prop: 'assignTime', width: '180' },
        { label: '最后跟进时间', prop: 'lastFollowTime', width: '180' },
        { label: '订单数', prop: 'orderCount', width: '100' },
        { label: '类目ID', prop: 'categoryId', width: '100' },
        { label: '类目名称', prop: 'categoryName', width: '120' },
        { label: '最后下单时间', prop: 'lastOrderTime', width: '180' },
        { label: '创建时间', prop: 'createdTime', width: '180' },
        { label: '更新时间', prop: 'updatedTime', width: '180' },
        { label: '地址', prop: 'address', width: '200' },
        { label: '详细地址', prop: 'detailedAddress', width: '200' },
        { label: '客户类别', prop: 'customerCategory', width: '120' },
        { label: '用户描述', prop: 'userDescription', width: '200' },
        { label: '其他内容', prop: 'otherContent', width: '200' },
        { label: '备注', prop: 'remark', width: '200' },
        {
          label: '操作',
          width: '100',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-link size='mini' type='primary' onClick={() => { this.onDetail(scope.row) }}>查看</el-link>
              </div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 },
      exportLoading: false
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData (type) {
      if (type === 'reset') {
        this.search = {
          year: new Date().getFullYear().toString(),
          hasOrder: ''
        }
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.customPageSize = null
      }
      
      const params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      
      // 始终添加搜索条件（修复翻页时过滤参数丢失的问题）
      if (this.search.year) {
        params.year = parseInt(this.search.year)
      }
      if (this.search.hasOrder !== '') {
        params.hasOrder = this.search.hasOrder
      }
      
      console.log('查询参数:', params)
      
      this.$api.customerRecycleQuery(params).then((res) => {
        if (res.code === 0) {
          this.list = res.data.list || []
          this.page.totalNum = res.data.totalNum || 0
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error('查询失败')
      })
    },
    
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.page.pageNo = 1 // 改变每页条数时重置到第一页
      this.fetchData()
    },
    
    // 应用自定义每页条数
    applyCustomPageSize () {
      if (this.customPageSize && this.customPageSize > 0 && this.customPageSize <= 1000) {
        this.page.pageSize = this.customPageSize
        this.page.pageNo = 1
        this.fetchData()
        this.$message.success(`已设置每页显示${this.customPageSize}条数据`)
      } else if (this.customPageSize !== null && this.customPageSize !== '') {
        this.$message.warning('请输入1-1000之间的数字')
      }
    },
    
    // 导出Excel
    handleExport () {
      const params = {
        pageNo: 1,
        pageSize: 10000 // 导出时使用较大的页面大小
      }
      
      // 添加搜索条件
      if (this.search.year) {
        params.year = parseInt(this.search.year)
      }
      if (this.search.hasOrder !== '') {
        params.hasOrder = this.search.hasOrder
      }
      
      this.exportLoading = true
      
      this.$api.customerRecycleExport(params).then((res) => {
        if (res.code === 0 && res.data) {
          const { excelUrl, fileName, totalCount, exportCount } = res.data
          
          this.$message.success(`导出成功！共${totalCount}条数据，已导出${exportCount}条`)
          
          // 创建隐藏的a标签进行下载
          const link = document.createElement('a')
          link.href = excelUrl
          link.download = fileName || '客户回收资源.xlsx'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          this.$message.error(res.message || '导出失败')
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error('导出失败')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    
    // 查看客户详情
    onDetail (row) {
      console.log(row)
      this.$router.push({
        name: 'customerInformation',
        query: {
          id: row.customerId,
          navName: 1
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}
.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 100%;
    max-width: 303px;
    min-width: 299px;
    /deep/.el-form-item__label{
      width: 80px;
    }
    /deep/.el-form-item__content {
      width: calc(100% - 80px);
      .el-select, .el-date-editor, .el-input {
        width: 100%;
      }
    }
  }
}

.content {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #ffffff;
  h2 {
    position: relative;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 20px;
  }
  h3 {
    position: relative;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 18px;
  }
  .el-button {
    margin-bottom: 10px;
  }
}
</style>

<style lang="scss">
.content {
  .el-link {
    margin: 0 5px;
  }
}
/deep/.el-scrollbar{
  height:10px;
}
/deep/.el-scrollbar__bar.is-horizontal{
  height: 9px;
}
</style>
